import type { NomenclatureItem } from '@/features/common/types/NomenclatureItem';
import type { Language } from '@/i18n/types';

/**
 * A content item's category as the reader's language names it.
 *
 * The item stores one text, the Romanian name picked from CONTENT_CATEGORII — or words typed by
 * hand. In English the nomenclature item with that Romanian name, matched whatever the case and
 * the spaces at either end, gives its English name. Anything else stays as stored: a category typed
 * by hand, an item no longer in use, an item with no English name, and every category in Romanian.
 *
 * For what a reader sees only. A filter or a request still carries the stored text, which is what
 * the server compares.
 */
export function categoryLabel(
  stored: string,
  language: Language,
  items: Pick<NomenclatureItem, 'nameRo' | 'nameEn'>[],
): string {
  if (language !== 'en') return stored;
  const key = stored.trim().toLowerCase();
  const match = items.find((item) => item.nameRo.trim().toLowerCase() === key);
  return match?.nameEn?.trim() || stored;
}
